<template>
  <div>
    <b-tooltip
      size="is-large"
      :label="tooltipLabel"
      :position="tooltipPosition">
      <a @click="checkPermissions(permissions) ? openPopUp() : showPopUp()">
        <slot :hasPermission="checkPermissions(permissions)"/>
      </a>
    </b-tooltip>
    <b-modal
      v-model="popup"
      has-modal-card
      class="modal"
      @close="closePopUp">
      <popUpPrevention
        :messHeader="title"
        :messFooter="subtitle"
        :messDescription="messDescription"
        :questions="questions"
        :labelCheckbox="labelCheckbox"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        :messagesPopup="messagesPopup"
        :isErrorPopup="isErrorPopup"
        @update:isErrorPopup="messagesPopup = []"
        @yes="confirm"
        @validateQuestions="confirm"
        @no="closePopUp"
      />
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';

const permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    permissions: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    subtitle: {
      type: String,
      required: false,
      default: '',
    },
    labelCheckbox: {
      type: String,
      required: false,
    },
    query: {
      type: Function,
      required: true,
    },
    validation: {
      type: Function,
      required: false,
      default: () => {},
    },
    successMessage: {
      type: String,
      required: false,
    },
    messDescription: {
      type: String,
      required: false,
    },
    questions: {
      type: Array,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    tooltipLabel: {
      type: String,
      required: false,
      default: '',
    },
    tooltipPosition: {
      type: String,
      required: false,
      default: 'is-top',
    },
  },
  data() {
    return {
      popup: false,
      messagesPopup: [],
    };
  },
  components: {
    popUpPrevention,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    isErrorPopup() {
      return this.messagesPopup.length > 0;
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    openPopUp() {
      if (this.disabled) return;
      this.popup = true;
    },
    closePopUp() {
      this.messagesPopup = [];
      this.popup = false;
    },
    checkCatchError(response, messages) {
      if (response.error.validationErrors.length !== messages.length) {
        messages.push({ message: 'general.messages.error.untranslateError' });
      }
    },
    async confirm(event) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.query(event);
        if (this.successMessage) messageSucces(this.successMessage);
        this.closePopUp();
        loadingComponent.close();
        this.$emit('done');
      } catch (e) {
        loadingComponent.close();
        if (e.response) {
          this.validation(e.response, this.messagesPopup);
          this.checkCatchError(e.response.data, this.messagesPopup);
        } else {
          messageErreur(this.$i18n);
        }
        throw e;
      }
    },
  },
};
</script>

<style>

</style>
